import { IGetFaqsDTO } from '@/models/faq.model';
import { PaginationFields } from '@/models/pagination.model';

class GetFaqsDTO implements IGetFaqsDTO {
  channelId: number;

  question?: string;

  answer?: string;

  [PaginationFields.PAGE]?: number;

  [PaginationFields.PAGE_SIZE]?: number;

  constructor({
    channelId,
    page = 1,
    question,
    answer,
  }: {
    channelId: number;
    page?: number;
    question?: string;
    answer?: string;
  }) {
    this.channelId = channelId;
    if (question) {
      this.question = question;
    }
    if (answer) {
      this.answer = answer;
    }
    this[PaginationFields.PAGE] = page;
    this[PaginationFields.PAGE_SIZE] = 10;
  }
}

export default GetFaqsDTO;
